import { AdminService } from 'src/app/services/admin/admin.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AdminGuard implements CanActivate {
  constructor(
    private AdminService: AdminService,
    private Router: Router
    )
  {

  }

canActivate(route: ActivatedRouteSnapshot): boolean {
  if (!this.AdminService.isAdmin()) {
    this.Router.navigate(['/login']);
    return false;
  }

  const requiredPermission = route.data['permission'];

  if (!requiredPermission) {
    return true;
  }

  const role = this.AdminService.role();
  if (role === 'admin') {
    return true;
  }

  const permissions = this.AdminService.getPermissions() || [];
  if (permissions.includes(requiredPermission)) {
    return true;
  }

  this.Router.navigate(['/not-found']);
  return false;
}
}
